import { createSelector } from 'reselect';
import { getTravellersValues } from '../../../../../Checkout/store/order/selectors';
export const getPassengersState = (state) => state.exchange.passengers;
export const getPassengersIds = createSelector(getPassengersState, Object.keys);
export const getSelectedPassengersIds = createSelector(getPassengersState, passengersState => Object.entries(passengersState).reduce((ids, [id, isSelected]) => [...ids, ...(isSelected ? [id] : [])], []));
export const getIsAllPassengersSelected = createSelector(getPassengersState, passengersState => Object.values(passengersState).every(value => value));
export const getPassengers = createSelector(getPassengersState, getTravellersValues, (passengersState, travellersValues) => {
    return travellersValues.map(traveller => (Object.assign(Object.assign({}, traveller), { isSelected: passengersState[traveller.id] })));
});
export const getPassengersForSelection = createSelector(getPassengers, passengers => {
    const linkedPassengersByParentId = new Map();
    passengers.forEach(passenger => {
        var _a;
        if (!passenger.linkedTraveller) {
            return;
        }
        const parentTravellerId = passenger.linkedTraveller.id;
        const linkedPassengers = (_a = linkedPassengersByParentId.get(parentTravellerId)) !== null && _a !== void 0 ? _a : [];
        linkedPassengers.push(passenger);
        linkedPassengersByParentId.set(parentTravellerId, linkedPassengers);
    });
    return passengers
        .filter(passenger => !passenger.linkedTraveller)
        .map(traveller => {
        var _a;
        const linkedTravellers = (_a = linkedPassengersByParentId.get(traveller.id)) !== null && _a !== void 0 ? _a : [];
        if (linkedTravellers.length) {
            return {
                ids: [traveller.id, ...linkedTravellers.map(linked => linked.id)],
                label: [traveller.values.fullName, ...linkedTravellers.map(linked => linked.values.fullName)].join(', '),
                isSelected: traveller.isSelected && linkedTravellers.every(linked => linked.isSelected)
            };
        }
        return {
            ids: [traveller.id],
            label: traveller.values.fullName,
            isSelected: traveller.isSelected
        };
    });
});
export const getSelectedPassengers = createSelector(getPassengers, passengers => passengers.filter(passenger => passenger.isSelected));
export const getSelectedPassengersParams = createSelector(getSelectedPassengers, (selectedPassengers) => {
    const passengersTypeMap = new Map();
    selectedPassengers.forEach(passenger => {
        var _a;
        const type = passenger.type;
        passengersTypeMap.set(type, ((_a = passengersTypeMap.get(type)) !== null && _a !== void 0 ? _a : 0) + 1);
    });
    return [...passengersTypeMap.entries()].map(([passengerType, count]) => ({
        passengerType,
        count
    }));
});
